import AddIcon from '@material-ui/icons/Add';
import {
  Box,
  Grid,
  IconButton,
  List,
  ListItem,
  ListItemSecondaryAction,
  ListItemText,
} from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import React from 'react';
import { Form } from 'react-hook-smartform';
import useAppData from '../../util/useAppData';
import TextField from '../../fields/TextField';
import SubmitFab from '../../fields/SubmitFab';
import { useTranslation } from 'react-i18next';

const CurrencySettings = () => {
  const { currencies, setCurrencies } = useAppData();
  const { t } = useTranslation();

  const add = currency => setCurrencies(cs => [...cs, currency]);
  const remove = index => setCurrencies(cs => [...cs.slice(0, index), ...cs.slice(index + 1)]);

  return (
    <Box margin={2}>
      <Grid container>
        <Grid item xs={12}>
          <Form onSubmit={add}>
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <TextField
                  name="value"
                  label={t('currencies.value')}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  name="name"
                  label={t('currencies.name')}
                />
              </Grid>
              <Grid item xs={12}>
                <Grid container spacing={2} justifyContent="flex-end">
                  <Grid item>    
                    <SubmitFab
                      icon={AddIcon}
                      size="small"
                      disableIfClean={false}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Form>
        </Grid>
        <Grid item xs={12}>
          <List>
            {currencies.map(({ name, value }, i) => (
              <ListItem key={value}>
                <ListItemText primary={name} secondary={value} />
                <ListItemSecondaryAction>
                  <IconButton edge="end" onClick={() => remove(i)}>
                    <DeleteIcon />
                  </IconButton>
                </ListItemSecondaryAction>
              </ListItem>
            ))}
          </List>
        </Grid>
      </Grid>
    </Box>
  );
}

export default CurrencySettings;